import React, { useEffect } from 'react';
import { BrannanWebsiteHeaderSettings } from '@apps/guest/websiteHeader';
import { FullWidthLayout } from './layouts/FullWidth';
import { EventNameNavProps } from './components/EventNameNav';
import { CenterLayout } from './layouts/Center';
import { PageWidthLayout } from './layouts/PageWidth';
import { PhotoSliderLayout } from './layouts/PhotoSlider';
import { PhotoTrioLayout } from './layouts/PhotoTrio';
import { isInIframe } from '@shared/utils/isInIframe';
import { sendMessageToParentWindow } from '@shared/utils/previewMessageBus';
import { NoPhotoLayout } from './layouts/NoPhoto';

export interface HeaderV2Props extends EventNameNavProps {
  websiteHeader: NonNullable<BrannanWebsiteHeaderSettings['websiteHeader']>;
  pageId?: string;
}

const isPreview = isInIframe();

/**
 * This set of header layouts utilizes the new `websiteHeader` object.
 *
 * Each layout will render:
 * - Title
 * - Nav
 * - Header Photo
 */
export const HeaderV2 = (props: HeaderV2Props) => {
  const { websiteHeader, ...restProps } = props;

  const headerPhoto = websiteHeader.headerPhoto;
  const showPlaceholder = isPreview && !!headerPhoto.presentationLayout;

  useEffect(() => {
    if (headerPhoto.presentationLayout) {
      sendMessageToParentWindow({ action: 'requestIframeScaleValue', source: 'joyPreview' });
    }
  }, [headerPhoto.presentationLayout]);

  switch (headerPhoto.presentationLayout) {
    // have to rebuild websiteHeader explicitly because despite the switch,
    // TSC complains about the discriminated union whose shared type is 2 levels deep

    case 'center':
      return <CenterLayout websiteHeader={{ ...websiteHeader, headerPhoto }} showPlaceholder={showPlaceholder} {...restProps} />;
    case 'fullWidth':
      return <FullWidthLayout websiteHeader={{ ...websiteHeader, headerPhoto }} showPlaceholder={showPlaceholder} {...restProps} />;
    case 'pageWidth':
      return <PageWidthLayout websiteHeader={{ ...websiteHeader, headerPhoto }} showPlaceholder={showPlaceholder} {...restProps} />;

    case 'photoSlider':
      return <PhotoSliderLayout websiteHeader={{ ...websiteHeader, headerPhoto }} showPlaceholder={showPlaceholder} {...restProps} />;

    case 'photoTrio':
      return <PhotoTrioLayout websiteHeader={{ ...websiteHeader, headerPhoto }} showPlaceholder={showPlaceholder} {...restProps} />;

    case 'noPhoto':
      return <NoPhotoLayout websiteHeader={{ ...websiteHeader, headerPhoto }} showPlaceholder={showPlaceholder} {...restProps} />;

    // case 'photoMarquee'
    // case 'photoArch':
    // case 'photoDuoLeft':
    // case 'photoDuoRight':

    default:
      return null;
  }
};

export default HeaderV2;
